import React from 'react'
import { connect } from 'react-redux'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import { forgotPasswordFormVisible, forgot } from '../../store/forgotPassword'
import TextField from 'material-ui/TextField'
import { message } from '../../store/messageBar'

class ForgotPasswordForm extends React.Component {

    handleClose = () => {
        this.forgotPasswordWindow(false);
    };

    handleForgotPassword = () => {
        this.forgot(this.state.email).then(()=>{
            this.handleClose();
            this.showMessage('Check your email');
        }).catch(e => {
            this.showMessage(e.response.data.error);
        });
    };

    handleInput = (e) => {
        this.setState({email: e.target.value});
    };

    constructor(props) {
        super(props);

        this.state = {
            showWindow: this.props.showWindow,
            email: ''
        };
        this.forgotPasswordWindow = this.props.forgotPasswordWindow;
        this.forgot = this.props.forgot;
        this.showMessage = this.props.showMessage;
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.showWindow !== this.state.showWindow) {
            this.setState({ showWindow: nextProps.showWindow });
        }
    }

    render() {
        const actions = [
          <FlatButton
              className={'main-btn'}
              label="CANCEL"
              primary={true}
              onClick={this.handleClose}
              style={{ color: "#333c8f"}}
          />,
          <FlatButton
              className={'main-btn'}
              label="SEND"
              primary={true}
              onClick={this.handleForgotPassword}
              style={{ color: "#333c8f"}}
          />,
        ];

        return (
            <div>
              <Dialog
                  title="Forgot password?"
                  actions={actions}
                  modal={true}
                  open={this.state.showWindow}
              >

                  <TextField
                      hintText="Email Field"
                      floatingLabelText="Email"
                      type="text"
                      id="email"
                      onChange={this.handleInput}
                      value={this.state.email}
                      underlineFocusStyle={{ borderColor: "#333c8f" }}
                      floatingLabelStyle={{ color: "#333c8f" }}
                  />

              </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        showWindow: state.forgotPasswordForm
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        forgotPasswordWindow: (value) => dispatch(forgotPasswordFormVisible(value)),
        forgot: (email, password) => dispatch(forgot(email)),
        showMessage: (text) => dispatch(message(text))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/ForgotPasswordForm.js